var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1041px",
    height: "1041px",
    viewBox: "0 0 1041 1041",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info_-active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0192_info_85pt",
    fill: "#2e2c7d",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.5,440 C459.028,440 440,459.028 440,482.5 L440,682.5 C440,705.972 459.028,725 482.5,725 C505.972,725 525,705.972 525,682.5 L525,482.5 C525,459.028 505.972,440 482.5,440 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.501,264.516 C450.531,264.516 424.522,290.529 424.522,322.502 C424.522,354.474 450.531,380.484 482.501,380.484 C514.47,380.484 540.479,354.473 540.479,322.502 C540.479,290.528 514.47,264.516 482.501,264.516 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.065,294.676 C902.761,237.215 867.977,185.619 823.679,141.321 C779.381,97.023 727.784,62.239 670.324,37.935 C610.812,12.763 547.619,0 482.5,0 C417.381,0 354.188,12.763 294.676,37.935 C237.215,62.239 185.619,97.023 141.321,141.321 C97.023,185.619 62.239,237.215 37.935,294.676 C12.763,354.188 0,417.381 0,482.5 C0,547.619 12.763,610.812 37.935,670.324 C62.239,727.785 97.023,779.381 141.321,823.679 C185.619,867.977 237.215,902.762 294.676,927.065 C354.188,952.237 417.381,965 482.5,965 C547.619,965 610.812,952.237 670.324,927.065 C727.785,902.761 779.381,867.977 823.679,823.679 C867.977,779.381 902.762,727.784 927.065,670.324 C952.237,610.812 965,547.619 965,482.5 C965,417.381 952.237,354.188 927.065,294.676 Z M848.78,637.212 C828.762,684.541 800.094,727.056 763.575,763.575 C727.055,800.094 684.541,828.762 637.212,848.78 C588.233,869.496 536.181,880 482.5,880 C428.819,880 376.767,869.496 327.788,848.78 C280.459,828.762 237.944,800.094 201.425,763.575 C164.906,727.055 136.239,684.541 116.22,637.212 C95.504,588.233 85,536.181 85,482.5 C85,428.819 95.504,376.767 116.22,327.788 C136.238,280.459 164.906,237.944 201.425,201.425 C237.944,164.906 280.459,136.239 327.788,116.22 C376.767,95.504 428.819,85 482.5,85 C536.181,85 588.233,95.504 637.212,116.22 C684.541,136.238 727.056,164.906 763.575,201.425 C800.094,237.944 828.762,280.459 848.78,327.788 C869.496,376.767 880,428.819 880,482.5 C880,536.181 869.496,588.233 848.78,637.212 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ff4e8af2ac2765e1b616ee70945cc7ce.svg";
export { ForwardRef as ReactComponent };